import React, { useState } from "react";
import { Col, Container, Form, Row, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import forgetPasswordImg from "../../../../img/verification.svg";
import { useSendPasswordResetEmail } from "react-firebase-hooks/auth";
import { auth } from "../../../../firebase.init";
import { toast } from "react-toastify";
const ForgetPassword = () => {
  const [validated, setValidated] = useState(false);
  const [forgetEmail, setForgetEmail] = useState("");

  //   handle Toast
  const toastId = React.useRef(null);
  const notify = () =>
    (toastId.current = toast("Sending", { autoClose: true }));
  const update = () =>
    toast.update(toastId.current, {
      render: "Successfully Send",
      type: toast.TYPE.SUCCESS,
      autoClose: 1000,
    });

  const [sendPasswordResetEmail, sending, error] =
    useSendPasswordResetEmail(auth);
  const handleToOnChange = (event) => {
    setForgetEmail(event.target.value);
  };

  const handleForgetPass = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
    }
    await sendPasswordResetEmail(forgetEmail);
    update();

    setValidated(true);
  };
  if (error) {
    return (
      <div>
        <p>Error: {error.message}</p>
      </div>
    );
  }
  if (sending) {
    notify();
  }

  return (
    <div>
      <Container>
        <Row>
          <Row>
            <Col md={6}>
              <img src={forgetPasswordImg} alt="Login Now" />
            </Col>
            <Col className="my-5" md={6}>
              {" "}
              <Form
                id="loginFrom"
                onSubmit={handleForgetPass}
                noValidate
                validated={validated}
              >
                {/* Email */}
                <Form.Group
                  as={Col}
                  md="12"
                  className="mt-3"
                  controlid="validationCustom02"
                >
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    required
                    name="email"
                    type="email"
                    placeholder="mail@domain.com"
                    value={forgetEmail}
                    onChange={handleToOnChange}
                  />
                  <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                </Form.Group>
                <br />
                <Button variant="success" type="submit">
                  Submit
                </Button>
                <br />
                <br />
                <p>
                  Or you can <Link to="/login"> Login</Link>
                </p>
              </Form>
              <br />
            </Col>
          </Row>
        </Row>
      </Container>
    </div>
  );
};

export default ForgetPassword;
